export const filter = {
    id: "",
    discount: "",
    status: "",
    user_id: "",
    search: "",
    created_at: "",
    updated_at: "",
};
